import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import types from '../../types';
import {
    Dropdown,
} from 'react-bootstrap';
import Select from 'react-select';
import { openModal, updateValueModal, closeModal } from '../../actions/modal.action';
import { moveSampleOnSection } from '../../actions/survey.sample.action';
import { useParams } from 'react-router-dom';
import { getSectionNameByCodeAndSurvey } from '../../actions/helpers/section.helper';
import { SAMPLE_PLACES_TO_MOVE } from '../../constants/common';

const titles = {
    above: 'Do you want to move this question above?',
    below: 'Do you want to move this question below?',
    top: 'Do you want to move this question to the top?',
    bottom: 'Do you want to move this question to the bottom?',
}

const MoveQuestionToSection = ({ questionId, identifier }) => {
    const storeJwt = useSelector((state) => state.session.jwt);
    const dispatch = useDispatch();
    const { id: surveyId } = useParams();
    const { surveys } = useSelector((state) => state.surveySummary);
    const { allSections } = useSelector((state) => state.sections);
    const [sections, setSections] = useState([]);

    const handleSectionChange = (selectedOption) => {
        updateValueModal({
            sectionCode: selectedOption?.value,
            sectionName: selectedOption?.name,
            identifier,
            surveyId,
        })(dispatch);
    };

    const onMoveHandle = () => {
        openModal({
            title: 'Move questions To Section',
            className: 'modal-alert-width',
            button1Text: 'Cancel',
            button1Action: 'closeModal',
            button2Text: 'Move',
            hasValue: true,
            button2Action: (value) => {
                dispatch({
                    type: types.reducerTypes.UPDATING_SECTION_ON_QUESTION,
                    payload: {
                        section: value,
                        questionId
                    }
                });
                closeModal()(dispatch);
            },
            body: <>
                <Select
                    isClearable
                    className="w-100"
                    placeholder="Select survey section"
                    isSearchable
                    closeMenuOnSelect={true}
                    options={sections.map((section) => ({
                        label: `${section.code} - ${section.name}`,
                        value: section.code,
                        name: section.name,
                    }))}
                    onChange={handleSectionChange}
                />
            </>,
        })(dispatch);
    };


    useEffect(() => {
        if (surveyId && surveys?.length && identifier) {
            const survey = surveys.find((s) => Number(s.id) === Number(surveyId));
            if (survey) {
                const currentSectionCode = identifier.split('_')[2]; 
                const sections = survey.surveySummaryDetailsDto?.sectionCodes
                    .split(', ')
                    .filter((section) => section.trim().toLowerCase() !== currentSectionCode.toLowerCase())
                    .sort((a, b) => {
                        if (a === b) {
                            return 0;
                        }
                        return a < b ? -1 : 1;
                    })
                    .map((code) => {
                        const selectedSectionCode = code.trim().toLowerCase();
                        const sectionName = getSectionNameByCodeAndSurvey(
                            selectedSectionCode,
                            survey,
                            allSections
                            
                        );
                        return {
                            name: sectionName,
                            code: selectedSectionCode,
                        };
                    });
                setSections(sections);
            } else {
                setSections([]);
            }
        }
    }, [surveyId, identifier, surveys, allSections]);

    const onReorderQuestion = (title, place) => {
        openModal({
            title: title,
            className: 'modal-alert-width',
            button1Text: 'Cancel',
            button1Action: 'closeModal',
            button2Text: 'Yes',
            button2Action: (value) => {
                dispatch({
                    type: types.reducerTypes.UPDATING_SECTION_ON_QUESTION,
                    payload: {
                        section: value,
                        questionId
                    }
                });
                dispatch(moveSampleOnSection(questionId, place, surveyId, storeJwt));
                closeModal()(dispatch);
            },
            body: '',
        })(dispatch);
    };
    return (
        <>
        <Dropdown.Item onClick={() => onReorderQuestion(titles.above, SAMPLE_PLACES_TO_MOVE.ABOVE)}> Move above</Dropdown.Item>
        <Dropdown.Item onClick={() => onReorderQuestion(titles.below, SAMPLE_PLACES_TO_MOVE.BELOW)}> Move below </Dropdown.Item>
        <Dropdown.Item onClick={() => onReorderQuestion(titles.top, SAMPLE_PLACES_TO_MOVE.TOP)}> Move to the top </Dropdown.Item>
        <Dropdown.Item onClick={() => onReorderQuestion(titles.bottom, SAMPLE_PLACES_TO_MOVE.BOTTOM)}> Move to the bottom </Dropdown.Item>
        <Dropdown.Item onClick={onMoveHandle}> Move to another section </Dropdown.Item>
        </>
    );
};

export default MoveQuestionToSection;
